import { Controller } from "@hotwired/stimulus"

// Dispatches a window event so the survey-result-editor controller
// can save progress before navigating back.
//
// This controller is page-level chrome -- it connects independently of the
// survey editor and is never gated on survey data having loaded (card
// #2841). When the survey HAS loaded, though, the save-and-back handler
// does a real network round trip (save progress) before navigating, which
// can take several seconds on a slow connection with no other visual cue.
// Disabling immediately on tap means a tap is never left looking like
// nothing happened, however long that round trip takes -- the button stays
// disabled until the page actually navigates away, so there's nothing to
// re-enable on the success path.
export default class extends Controller {
  static values = { path: String }

  save() {
    this.element.disabled = true
    this.element.classList.add("opacity-40")

    window.dispatchEvent(new CustomEvent("field:save-and-back", {
      detail: { path: this.pathValue }
    }))
  }
}
